import { Injectable } from "@angular/core";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IRiskTradeLookupService } from "../IRiskTradeLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export abstract class RiskTradeLookupService
  extends BaseLookupService<string, CubiqTS.DealImpl>
  implements IRiskTradeLookupService
{
  constructor() {
    super(CubiqTS.DealImpl);
  }

  mapItem(item: CubiqTS.DealImpl): void {
    if (this.myItemMap.has(this.getItemKey(item))) {
      let oldItem = this.getItem(this.getItemKey(item));
      this.deleteItem(oldItem);
    }

    let itemKey = this.getItemKey(item);
    if (itemKey != null) {
      this.myItemMap.set(itemKey, item);
    } else {
      logger.out.warn(
        `${this.constructor.name}.mapItem(item: %o) dropping item with invalid key`,
        item,
      );
    }
  }

  getItemKey(item: CubiqTS.DealImpl): string {
    return item?.id?.toString();
  }
}

@Injectable()
export class LimitRiskTradeLookupService extends RiskTradeLookupService {}

@Injectable()
export class AlgoRiskTradeLookupService extends RiskTradeLookupService {}

@Injectable()
export class BMRiskTradeLookupService extends RiskTradeLookupService {}

@Injectable()
export class BMAlgoRiskTradeLookupService extends RiskTradeLookupService {}
